/**
 * Parses the brand info from the buckets
 *
 * @param {object} types - the bucket types
 * @returns {object} the brand info
 */
export default function parseBrandInfoFromBuckets (types) {
  return Object.keys(types).reduce((res, key) => {
    const type = types[key]

    res[key] = Object.keys(type)
      .flatMap(typeKey => {
        const style = type[typeKey]

        return Object.keys(style).flatMap(
          styleKey => style[styleKey].categoriesBrands
        )
      })
      .filter(
        (value, index, self) =>
          index === self.findIndex(obj => obj.id === value.id)
      )

    return res
  }, {})
}
